module.exports = __webpack_public_path__ + "media/asset-1.8129a6be.mp4";